import { createTheme } from '@mui/material';

export const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: 'Roboto, sans-serif',
                    fontOpticalSizing: 'auto',
                    fontWeight: 400,
                    fontStyle: 'normal',
                }
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-input': {
                        color: '#1e4bb3',
                    },
                    '& .MuiInputBase-input::placeholder': {
                        color: '#1e4bb3',
                    },
                    '& .MuiInputLabel-root': {
                        color: '#1e4bb3',
                    },
                },
            },
        },
    },
    palette: {
        divider: '#666666',
        mode: 'light',
        primary: {
            light: '#1AC8ED',
            main: '#3277e5',
            dark: '#00003D',
            contrastText: '#ebebff',
        },
        text: {
            primary: '#0a0a0a',
            secondary: '#fdfaef',
            disabled: '#bbbbbb',
        },
        secondary: {
            light: '#ebebff',
            main: '#ebebff',
            dark: '#AE0843',
        },
        background: {
            default: '#ffffff',
            paper: '#ffffff',
        },
        error: {
            main: '#ba000d',
        },
    }
});
